import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { CSSProperties } from 'react'
import { Controller } from 'react-hook-form'

import { helper } from 'helper'
import { ControlProps } from 'helper/control'
import { WeekKey } from 'helper/week'
import ShiftLabelComponent from 'pages/shift/show/components/shiftLabel'
import SimpleSelectorComponent from 'pages/shift/show/components/simpleSelector'
import { Option } from 'types/option'
import { FIX_SHIFT, FixShift } from 'types/securityDetail'
import { colors, Icons } from 'variables'

type FieldType = FixShift[]

const options: Option<FixShift>[] = [
  {
    value: FIX_SHIFT.UNSELECT,
    label: '-',
  },
  {
    value: FIX_SHIFT.OK,
    label: 'o',
  },
  {
    value: FIX_SHIFT.NG,
    label: 'x',
  },
]

export default function FixedShiftsForm(props: ControlProps) {
  const handleSelect =
    (
      field: {
        value: FieldType
        onChange: (value: FieldType) => void
      },
      daysIndex: number,
    ) =>
    (opt: Option<FixShift>): void => {
      const newValue: FieldType = field.value == null ? [] : [...field.value]

      newValue[daysIndex] = opt.value
      field.onChange(newValue)
    }
  return (
    <Controller
      {...props.c}
      render={({ field }) => (
        <>
          {helper.week.dayOfWeeks(true).map((week, i) => (
            <Box style={selectContainerStyle} key={week}>
              <Typography style={weekColorStyle(week)}>{week}</Typography>
              <SimpleSelectorComponent
                options={() => options}
                onSelect={handleSelect(field, i)}
                render={(option) => (
                  <Button style={selectButtonStyle}>
                    <CellComponent value={option.value} />
                  </Button>
                )}
              >
                <Box style={cellStyle}>
                  <CellComponent value={field.value[i] ?? FIX_SHIFT.UNSELECT} />
                </Box>
              </SimpleSelectorComponent>
            </Box>
          ))}
        </>
      )}
    />
  )
}

const CellComponent = (props: { value: FixShift }) => {
  switch (props.value) {
    case FIX_SHIFT.OK:
      return (
        <ShiftLabelComponent style={answerOkCellStyle}>
          <Icons.answerOk />
        </ShiftLabelComponent>
      )
    case FIX_SHIFT.NG:
      return (
        <ShiftLabelComponent style={answerNgCellStyle}>
          <Icons.answerNg />
        </ShiftLabelComponent>
      )
    case FIX_SHIFT.UNSELECT:
      return (
        <ShiftLabelComponent style={answerUnselectCellStyle}>
          -
        </ShiftLabelComponent>
      )
  }
}

const selectContainerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
}

const cellStyle: CSSProperties = {
  scale: '0.8',
}

const selectButtonStyle: CSSProperties = {
  padding: 0,
}

const answerOkCellStyle: CSSProperties = {
  color: '#5F6E6E',
  backgroundColor: '#B8E9E7',
}

const answerNgCellStyle: CSSProperties = {
  color: 'white',
  backgroundColor: '#AFB6B6',
}

const answerUnselectCellStyle: CSSProperties = {
  color: '#333',
  backgroundColor: 'white',
  border: 'solid 1px #B4BEBE',
}

const weekColorStyle = (week: WeekKey): CSSProperties => {
  // 祝日の表示が無いため、日曜だけ
  if (week === '日') {
    return {
      // 日曜日
      color: colors.WEEK.SUN_COLOR,
    }
  }

  if (week === '土') {
    return {
      // 土曜日
      color: colors.WEEK.SAT_COLOR,
    }
  }

  return {
    // 平日 (色の上書き無し)
  }
}
